// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import ReactDragListView from 'react-drag-listview/lib/index.js';

import {
    Table,
    Col,
    Row,
    UncontrolledTooltip,
} from "reactstrap"
import { IoIosAdd } from "react-icons/io";
import { GrDrag } from "react-icons/gr";


//import components
import Breadcrumbs from 'components/_Common/Breadcrumb';
import DeleteModal from "components/_Common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";

// actions
import { deleteLanguage, listLanguage, editLanguage } from "store/actions";
import AddEditModal from "../AddEdit/AddEditModal";
import toastr from "toastr";
import MyPagination from "components/_Common/MyPagination";
import { onSortLanguage } from "helpers/backend_api_helper";
import { withTranslation } from "react-i18next";
import DataNoFound from "components/_Common/DataNoFound";
import Switch from 'react-switch';


const List = props => {
    //meta title
    document.title = `${props.t("Schor Horizontal")}  | ${props.t("Admin")}`;

    const { error, success, loading ,editLoading} = useSelector(state => ({
        loading: state.configurationsLanguages.loading,
        error: state.configurationsLanguages.error,
        success: state.configurationsLanguages.success,
        editLoading: state.configurationsLanguages.editLoading
    }));

    const dispatch = useDispatch();
    const navigate = useNavigate()
    console.log(editLoading,loading)

    const [modal, setModal] = useState(false);
    const [itemData, SetItemData] = useState();
    const [tableData, SetTableData] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [currentPage, setCurrentPage] = useState(1)
    const [filterData, setFilterData] = useState({
        "limit": 25,
        "page": currentPage,
        "search": ""
    });

    const toggle = () => {
        if (modal) {
            setModal(false);

        } else {
            setModal(true);
        }
    };
    //delete question
    const [deleteModal, setDeleteModal] = useState(false);
    const onClickDelete = (item) => {
        SetItemData(item)
        setDeleteModal(true);
    };
    const handleDeleteLanguage = () => {
        dispatch(deleteLanguage({ ids: [itemData?.id] }, (res) => {
            if (res?.status === 'success') {
                setDeleteModal(false);
                toastr.success(res?.message)
                // fetchListLanguage()
                setFilterData(prevFilterData => ({
                    ...prevFilterData,
                    randomEvent: Math.random()
                }));

            } else {
                toastr.error(res?.message)
            }
        }))
    };

    // edit 
    const handleQuestionClick = data => {
        setIsEdit(true);
        SetItemData(data)
        toggle();
    };

    // list
    const fetchListLanguage = (filterData) => {
        dispatch(listLanguage(filterData, (res) => {
            if (res?.status === 'success') {
                SetTableData(res?.data)
                SetItemData({})
            }
        }))
    }
    useEffect(() => {
        fetchListLanguage(filterData)
    }, [currentPage, filterData?.search, filterData?.limit, filterData?.question_type])

    // filter 
    const debounce = (func, delay) => {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    };

    // Function to handle search
    const handleSearch = debounce((searchTerm) => {
        setFilterData(prevFilterData => ({
            ...prevFilterData,
            search: searchTerm
        }));
    }, 500);

    const handleLimit = (val) => {
        setFilterData(prevFilterData => ({
            ...prevFilterData,
            limit: val
        }));
    }
    // sorting row
    const handleChangeRow = async (oldIndex, newIndex, id) => {
        let data = { oldIndex, newIndex }
        try {
            const onRowSortRes = await onSortLanguage(data, id);
            if (onRowSortRes.status === 'success') {
                toastr.success(onRowSortRes?.message)
            }
        } catch (error) {
            toastr.error(error?.response?.data?.message || "Server Error")

        }
    }

    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
            const modifiedData = [...tableData?.languages];
            const item = modifiedData.splice(fromIndex, 1)[0];
            modifiedData.splice(toIndex, 0, item);
            // handleChangeRow(item?.sort, toIndex, item?.id)
            handleChangeRow(fromIndex + 1, toIndex + 1, item?.id)
            SetTableData({ languages: modifiedData, records: tableData?.records });

        },
        nodeSelector: 'tr',
        handleSelector: 'tr'
    };

    const [checked, setChecked] = useState(false);
    const handleStatusChange = (item, checkVal) => {
        dispatch(editLanguage(
        {
            is_active: checkVal,
            label: item.label,
            code: item.code

        }, 
        item.id, 
        (res) => {
            if (res.status === 'success') {
                toastr.success(res.message)
                fetchListLanguage(filterData)

            } else {
                toastr.error(res.message)                

            }
        }));
    };

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteLanguage}
                onCloseClick={() => setDeleteModal(false)}
                loading={loading}
                modalContent={props.t("Are you sure delete?")}
            />
            <AddEditModal
                modal={modal}
                toggle={toggle}
                isEdit={isEdit}
                itemData={itemData}
                fetchLanguageListData={() => fetchListLanguage(filterData)}
            />
            <div className="page-content table-main-config-lang-list">
                <div className="container-fluid">
                    <Breadcrumbs title={props.t("Configuration")} breadcrumbItem={props.t("Manage Languages")} />

                    <Row>
                        <Col lg="12">
                            <Row className="mb-2 d-flex show-select justify-spacebetween">
                                <Col md={1} className="me-4 space-marg-rem">
                                    <select
                                        className="form-select custm-select"
                                        onChange={(e) => handleLimit(e.target.value)}
                                    >
                                        <option value="25">
                                            {props.t("Show")} 25
                                        </option>
                                        <option value="50">
                                            {props.t("Show")} 50
                                        </option>
                                        <option value="75">
                                            {props.t("Show")} 75
                                        </option>
                                        <option value="100">
                                            {props.t("Show")} 100
                                        </option>
                                    </select>
                                </Col>
                                <Col md={2}>
                                    <div className="search-box d-inline-block">
                                        <div className="position-relative">
                                            <label htmlFor="search-bar-0" className="search-label">
                                                <input
                                                    onChange={e => {
                                                        handleSearch(e.target.value);
                                                    }}
                                                    id="search-bar-0"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={props.t("Search") + "..."}
                                                />
                                            </label>
                                            <i className="bx bx-search-alt search-icon"></i>
                                        </div>
                                    </div>

                                </Col>

                                <Col md={4}></Col>
                                <Col md={4} className="text-end pe-0">

                                    <div className="custm-btns">
                                        <button
                                            onClick={() => {
                                                setModal(true)
                                                setIsEdit(false)
                                                SetItemData({})
                                            }}
                                            className="btn btn-primary"
                                        >
                                            {props.t("Add Language")}
                                        </button>
                                        {/* <Link onClick={() => fetchQuestionList(filterData)} className="btn btn-light me-1"><i className="mdi mdi-refresh"></i></Link> */}
                                    </div>
                                </Col>

                            </Row>
                            <div className="table-responsive">
                                {
                                     loading ?
                                        <div className="loader d-flex justify-content-center align-items-center mt-5" >
                                            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                            {props.t("Loading")}
                                        </div>
                                        :
                                        // <ReactDragListView {...dragProps}>
                                        <Table className="table mb-0">
                                            <thead>
                                                <tr>
                                                    {/* <th></th> */}
                                                    {/* <th>#</th> */}
                                                    <th>{props.t("Code")}</th>
                                                    <th className="main-data-fix-width">{props.t("Name")}</th>
                                                    <th>{props.t("Status")}</th>
                                                    {/* <th>{props.t("Created_At")}</th> */}
                                                    <th style={{ textAlign: "center", paddingRight: "25px" }}>{props.t("Action")}</th>
                                                </tr>
                                            </thead>
                                            {
                                                tableData?.languages?.length <= 0
                                                    ?
                                                    <tr>
                                                        <td colSpan="5" className="text-center no-record-found">{props.t("No Record Found")}</td>
                                                    </tr>
                                                    :
                                                    <tbody>
                                                        {(tableData?.languages || []).map((item, index) => (
                                                            <tr key={index}>
                                                                {/* <td><GrDrag size={12} style={{ cursor: "pointer" }} /></td> */}
                                                                {/* <td scope="row" className="drag-pointer">{item.id}</td> */}
                                                                <td>{item?.code}</td>
                                                                <td>{item?.label}</td>
                                                                <td><button className={item?.is_active === 'Y' ? "yes-btn" : "no-btn"}> {item?.is_active === 'Y' ? "Active" : "In-Active"}</button></td>

                                                                {/* <td>
                                                                      {item?.created_at}
                                                                    </td> */}
                                                                <td>
                                                                    <ul className="list-unstyled hstack gap-1 mb-0">
                                                                        <li>
                                                                            <Switch
                                                                                checked={item?.is_active === 'Y' ? 1 : 0}
                                                                                onChange={() => handleStatusChange(item, item?.is_active === 'Y' ? 'N' : 'Y')}
                                                                                uncheckedIcon={false}
                                                                                checkedIcon={false}
                                                                                className="react-switch"
                                                                                id="material-switch"
                                                                            />
                                                                        </li>
                                                                        <li>
                                                                            <span
                                                                                className="btn btn-sm btn-soft-info"
                                                                                onClick={() => {
                                                                                    handleQuestionClick(item);
                                                                                }}
                                                                            >
                                                                                <i className="bx bx-edit" id={`edittooltip${item?.id}`} />
                                                                                <UncontrolledTooltip placement="top" target={`edittooltip${item?.id}`}>
                                                                                    {props.t("Edit")}
                                                                                </UncontrolledTooltip>
                                                                            </span>
                                                                        </li>

                                                                        {/* <li>
                                                                            <span
                                                                                className="btn btn-sm btn-soft-danger"
                                                                                onClick={() => {
                                                                                    onClickDelete(item);
                                                                                }}
                                                                            >
                                                                                <i className="bx bx-trash" id={`deletetooltip${item?.id}`} />
                                                                                <UncontrolledTooltip placement="top" target={`deletetooltip${item?.id}`}>
                                                                                    {props.t("Delete")}
                                                                                </UncontrolledTooltip>
                                                                            </span>
                                                                        </li> */}
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                            }

                                        </Table>
                                    // </ReactDragListView>
                                }
                            </div>
                            {
                                tableData?.records < filterData?.limit ?
                                    ""
                                    :
                                    <MyPagination
                                        filterData={filterData}
                                        recordsPerPage={filterData?.limit}
                                        totalRecords={tableData?.records}
                                        currentPage={currentPage}
                                        onPageChange={(pageNumber) => {
                                            setCurrentPage(pageNumber)
                                            setFilterData(prevFilterData => ({
                                                ...prevFilterData,
                                                page: pageNumber
                                            }));
                                        }}
                                    />
                            }
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}

List.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(List);
